var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11L8.257 8.753L10.5 11ZM9.5 5.75C9.5 6.87717 9.05223 7.95817 8.2552 8.7552C7.45817 9.55223 6.37717 10 5.25 10C4.12283 10 3.04183 9.55223 2.2448 8.7552C1.44777 7.95817 1 6.87717 1 5.75C1 4.62283 1.44777 3.54183 2.2448 2.7448C3.04183 1.94777 4.12283 1.5 5.25 1.5C6.37717 1.5 7.45817 1.94777 8.2552 2.7448C9.05223 3.54183 9.5 4.62283 9.5 5.75V5.75Z",
    stroke: "var(--primary-color)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8df8e36d1f8b6d7a203075f81643786b.svg";
export { ForwardRef as ReactComponent };